var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { not } from '@ember/object/computed';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { attr, hasMany } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import { computed } from '@ember/object';
let merchantProfile = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('file-attr'), _dec13 = attr('file-attr'), _dec14 = attr('string'), _dec15 = hasMany('legacy/merchant-image', {
  async: false
}), _dec16 = hasMany('legacy/merchant-image', {
  async: false
}), _dec17 = attr('string'), _dec18 = attr('string'), _dec19 = attr('string'), _dec20 = attr('boolean', {
  defaultValue: false
}), _dec21 = attr('boolean', {
  defaultValue: false
}), _dec22 = attr('string'), _dec23 = attr('string'), _dec24 = attr('string'), _dec25 = attr('boolean', {
  defaultValue: false
}), _dec26 = attr('number'), _dec27 = attr('string'), _dec28 = fragmentArray('hours'), _dec29 = fragmentArray('special-hours'), _dec30 = hasMany('script-address'), _dec31 = attr('boolean', {
  defaultValue: true
}), _dec32 = attr('boolean', {
  defaultValue: true
}), _dec33 = attr('boolean', {
  defaultValue: true
}), _dec34 = attr('boolean', {
  defaultValue: false
}), _dec35 = attr('boolean', {
  defaultValue: false
}), _dec36 = attr('string'), _dec37 = attr('string'), _dec38 = attr('string'), _dec39 = attr('string'), _dec40 = attr('string'), _dec41 = attr('string'), _dec42 = attr('string'), _dec43 = attr('string'), _dec44 = attr('number'), _dec45 = attr('string'), _dec46 = attr('string'), _dec47 = attr('string'), _dec48 = attr('string'), _dec49 = attr('string'), _dec50 = attr('string'), _dec51 = attr('string'), _dec52 = attr('string'), _dec53 = attr('string'), _dec54 = attr('string'), _dec55 = attr('string'), _dec56 = attr('string'), _dec57 = not('hasDirtyAttributes'), _dec58 = computed('isDirty', 'hours.[]', function () {
  const dirtyAttributes = Object.keys(this.changedAttributes());
  // it isn't dirty if there aren't any dirty attributes
  if (dirtyAttributes.length === 0) {
    return false;
  }
  // it is dirty if there's some other dirty attribute besides hours
  if (!(dirtyAttributes.length === 1 && dirtyAttributes.includes('hours'))) {
    return true;
  }
  // it is dirty if we've added or deleted something that isn't a placeholder
  if (!this.hours.isAny('isPlaceholder')) {
    return true;
  }
  // it is dirty if we've modified hours, but not if we've added new placeholders to hours
  if (this.hours.isAny('isDirty')) {
    return true;
  }
  // otherwise, clean
  return false;
}), _class = (_class2 = class merchantProfile extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "token", _descriptor, this);
    _initializerDefineProperty(this, "slug", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "bio", _descriptor4, this);
    _initializerDefineProperty(this, "email", _descriptor5, this);
    _initializerDefineProperty(this, "phone", _descriptor6, this);
    _initializerDefineProperty(this, "cardColor", _descriptor7, this);
    _initializerDefineProperty(this, "twitter", _descriptor8, this);
    _initializerDefineProperty(this, "facebook", _descriptor9, this);
    _initializerDefineProperty(this, "instagram", _descriptor10, this);
    _initializerDefineProperty(this, "website", _descriptor11, this);
    _initializerDefineProperty(this, "profileImage", _descriptor12, this);
    _initializerDefineProperty(this, "profileBannerImage", _descriptor13, this);
    _initializerDefineProperty(this, "featuredImageUrl", _descriptor14, this);
    _initializerDefineProperty(this, "merchantImages", _descriptor15, this);
    _initializerDefineProperty(this, "posTerminalImages", _descriptor16, this);
    _initializerDefineProperty(this, "printedReceiptImageUrl", _descriptor17, this);
    _initializerDefineProperty(this, "customReceiptText", _descriptor18, this);
    _initializerDefineProperty(this, "returnPolicy", _descriptor19, this);
    _initializerDefineProperty(this, "pickupEnabled", _descriptor20, this);
    _initializerDefineProperty(this, "shippingEnabled", _descriptor21, this);
    _initializerDefineProperty(this, "preferredLanguage", _descriptor22, this);
    _initializerDefineProperty(this, "countryCode", _descriptor23, this);
    _initializerDefineProperty(this, "mcc", _descriptor24, this);
    _initializerDefineProperty(this, "mobileBusiness", _descriptor25, this);
    _initializerDefineProperty(this, "gmtOffset", _descriptor26, this);
    _initializerDefineProperty(this, "ianaTimeZone", _descriptor27, this);
    _initializerDefineProperty(this, "hours", _descriptor28, this);
    _initializerDefineProperty(this, "specialHours", _descriptor29, this);
    _initializerDefineProperty(this, "scriptAddresses", _descriptor30, this);
    // Receipt information
    _initializerDefineProperty(this, "receiptShowItemDescription", _descriptor31, this);
    _initializerDefineProperty(this, "receiptShowItemizedCartLevelDiscounts", _descriptor32, this);
    _initializerDefineProperty(this, "receiptShowLocation", _descriptor33, this);
    _initializerDefineProperty(this, "receiptShowReferral", _descriptor34, this);
    _initializerDefineProperty(this, "receiptShowTotalSavingsRow", _descriptor35, this);
    // Receipt information (CA only)
    _initializerDefineProperty(this, "gstHstNumber", _descriptor36, this);
    _initializerDefineProperty(this, "qstNumber", _descriptor37, this);
    // Receipt information (AUS only)
    _initializerDefineProperty(this, "abn", _descriptor38, this);
    // Receipt information (UK only)
    _initializerDefineProperty(this, "vatNumber", _descriptor39, this);
    // Receipt information (FR only)
    _initializerDefineProperty(this, "siretNumber", _descriptor40, this);
    _initializerDefineProperty(this, "nafCode", _descriptor41, this);
    _initializerDefineProperty(this, "frPlaceOfRegistration", _descriptor42, this);
    _initializerDefineProperty(this, "frCompanyFormation", _descriptor43, this);
    _initializerDefineProperty(this, "frShareCapital", _descriptor44, this);
    // Business names (JP only)
    _initializerDefineProperty(this, "secondaryName", _descriptor45, this);
    _initializerDefineProperty(this, "tertiaryName", _descriptor46, this);
    // JP only
    _initializerDefineProperty(this, "addressCode", _descriptor47, this);
    _initializerDefineProperty(this, "jpQiiNumber", _descriptor48, this);
    // NOTE: Without specifying `key` Ember Model will look for `address_line3`
    _initializerDefineProperty(this, "addressLine3", _descriptor49, this);
    _initializerDefineProperty(this, "ownerFirstName", _descriptor50, this);
    _initializerDefineProperty(this, "ownerLastName", _descriptor51, this);
    // From old ModelWithAddressSupport mixin
    _initializerDefineProperty(this, "street1", _descriptor52, this);
    _initializerDefineProperty(this, "street2", _descriptor53, this);
    _initializerDefineProperty(this, "city", _descriptor54, this);
    _initializerDefineProperty(this, "state", _descriptor55, this);
    _initializerDefineProperty(this, "postalCode", _descriptor56, this);
    _initializerDefineProperty(this, "isClean", _descriptor57, this);
    // If I change this to depend on 'hasDirtyAttributes' it doesn't recompute. I don't know why.
    // Maybe related: https://discuss.emberjs.com/t/computed-not-called-and-model-hasdirtyattributes/17589
    _initializerDefineProperty(this, "isDirtyWithoutHours", _descriptor58, this);
  }
}, _defineProperty(_class2, "url", '/api/v1/merchant-profile'), _defineProperty(_class2, "_modelNameForMigration", 'merchant-profile'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "token", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "slug", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bio", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phone", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "cardColor", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "twitter", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "facebook", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "website", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "profileImage", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "profileBannerImage", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "featuredImageUrl", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "merchantImages", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "posTerminalImages", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "printedReceiptImageUrl", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "customReceiptText", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "returnPolicy", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "pickupEnabled", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "shippingEnabled", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "preferredLanguage", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "countryCode", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "mcc", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "mobileBusiness", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "gmtOffset", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "ianaTimeZone", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "hours", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "specialHours", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "scriptAddresses", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "receiptShowItemDescription", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "receiptShowItemizedCartLevelDiscounts", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "receiptShowLocation", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "receiptShowReferral", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "receiptShowTotalSavingsRow", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "gstHstNumber", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "qstNumber", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "abn", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "vatNumber", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "siretNumber", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "nafCode", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "frPlaceOfRegistration", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "frCompanyFormation", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "frShareCapital", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "secondaryName", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "tertiaryName", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "addressCode", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "jpQiiNumber", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "addressLine3", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "ownerFirstName", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "ownerLastName", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "street1", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "street2", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "city", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "postalCode", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "isClean", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "isDirtyWithoutHours", [_dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { merchantProfile as default };